<template>
    <div>
      <p>
        {{questions}}
      </p>
      <p class="mt-1 font-semibold">Examples</p>
      <p>
        {{examples}}
      </p>
    </div>
</template>

<script>
export default {
  props: {
    questions: {
      type: String,
      required: true
    },
    examples: {
      type: String,
      required: true
    },
  },
}
</script>
